import React from 'react';

import { Box, Grid2 as Grid } from '@mui/material';
import { PostTypes, PostVisibilities } from '../../Utils/Types';

import PostCard from '../DesignSystem/PostCard';
import usePostsQuery from '../../Hooks/usePostsQuery';

export default function FoldersLayer({ space, parentId }: any) {
  const homePageView = !parentId;
  const { posts } = usePostsQuery(parentId ? 'subfolder' : 'folders', {
    space,
    limit: 100, // should be enough??
    parentId,
    types: [PostTypes.FOLDER],
    extraParams: {
      filter: homePageView ? { has_parent: true } : {},
    },
    sort: '-dates',
    visibilities: [PostVisibilities.PUBLISHED],
  });

  if (!posts.length) {
    return null;
  }

  return (
    <Box sx={{ wordBreak: 'break-word' }}>
      <Grid container spacing={2} sx={{ justifyContent: 'flex-start' }}>
        {posts.map((post: any) => (
          <Grid key={post.id} size={{ xs: 12, sm: 6, md: 4 }}>
            <PostCard key={post.id} post={post} entity={space} direction="row" />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}
